"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultTokenValueValidate = () => undefined;
exports.default = defaultTokenValueValidate;
